export enum BonusPayoutMethod {
  None = 'None',
  Cheque = 'Cheque',
  BankTransfer = 'BankTransfer',
  PayQuicker = 'PayQuicker',
  PmWallet = 'PmLedger'
}
